export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Классическая пятиклинка из 100% хлопка. Размер регулируется пластиковой застежкой. Подкладка отсутствует. Плотный изогнутый козырек с пластиковой вставкой хорошо держит нужную форму. Благодаря обшитым нитками люверсам, бейсболка отлично носится в жаркую погоду.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `<h3>Сублимация</h3><p>Перенос изображения осуществляется методом сублимации (термопереноса). Высокое качество покрытия создаёт яркое и сочное изображение. Оно как бы «приваривается» к поверхности, что обеспечивает его износостойкость и яркость красок. Наша продукция проверяется на герметичность.</p><p>Бейсболку с логотипом стирают в теплой воде с подходящим стиральным порошком или жидким средством. Сильно загрязненные места можно потереть влажной поролоновой губкой. Во избежание потери формы, бейсболку следует сушить на форме. Для этого ее можно набить целлофановыми пакетами или одеть на обычную трех- или двухлитровую банку.</p>`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
